import { render, staticRenderFns } from "./MyCalendarTasks.vue?vue&type=template&id=66533cbb&scoped=true"
import script from "./MyCalendarTasks.vue?vue&type=script&lang=js"
export * from "./MyCalendarTasks.vue?vue&type=script&lang=js"
import style0 from "./MyCalendarTasks.vue?vue&type=style&index=0&id=66533cbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66533cbb",
  null
  
)

export default component.exports